/**
 * Shared event emitter for the AzureSpeech native module.
 *
 * The Expo module object is itself the event emitter — addListener(name, cb)
 * returns a subscription with remove(). Both AzureSpeech.ts and
 * ConversationSpeech.ts listen through this single shared instance to avoid
 * duplicate subscriptions.
 *
 * Null on web (the module is not registered there) — each module handles
 * web events independently via webEventEmitter.
 */

import { requireOptionalNativeModule } from 'expo-modules-core';

interface SpeechEventEmitter {
  addListener(
    eventName: 'onRecognizing' | 'onWarning' | 'onSDKLog',
    listener: (event: never) => void,
  ): { remove: () => void };
}

// Single-line bare call (no generic) — jest-expo's auto-mock lookup matches
// this exact requireOptionalNativeModule('AzureSpeech') pattern by regex.
export const speechEventEmitter = requireOptionalNativeModule('AzureSpeech') as SpeechEventEmitter | null;
